import Slide from "@mui/material/Slide";
import React, {useEffect, useState} from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Toolbar from "@mui/material/Toolbar";

import {useAuth} from "oidc-react";
import {useDispatch, useSelector} from "react-redux";
import List from "@mui/material/List";
import {Chip, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, Switch} from "@mui/material";
import {
    Email,
    Group,
    Key, LocationCity,
    Phone, Wifi
} from "@mui/icons-material";
import Divider from "@mui/material/Divider";
import {loadUserGroups} from "../../features/user-management/user-managementAPI";
import {UserGroupEditMenu} from "../groups/menu/user-group-edit-menu";
import {AddUserToGroupModal} from "../groups/modals/add-user-to-group-modal";
import {RemoveUserFromGroupModal} from "../groups/modals/remove-user-from-group-modal";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const colors = [
    "primary",
    "secondary",
    "warning",
    "error",
    "info",
    "success"
];

export const UserFullInfo = ({ open, setOpen, user, reload }) => {

    const auth = useAuth();
    const dispatch = useDispatch();
    const [groups, setGroups] = useState([]);
    const [selectedUser, setSelectedUser] = useState({});
    const [showAddUserToGroupModal, setShowAddUserToGroupModal] = useState(false);
    const [showRemoveUserFromGroupModal, setShowRemoveUserFromGroupModal] = useState(false);

    const { iamGroups } = useSelector(state => state.iam)

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        loadGroupsForUser();
    }, [user]);

    const loadGroupsForUser = () => {
        loadUserGroups(auth.userData.access_token, user.username)
            .then(data => {
                setGroups(data)
            })
            .catch(err => {
                console.log(err);
            })
    }


    const handleSetShowRemoveUserFromGroupModal = () => {
        setShowAddUserToGroupModal(false);
        setShowRemoveUserFromGroupModal(true);
    }

    const handleSetAddUserToGroupModal = () => {
        setShowAddUserToGroupModal(true);
        setShowRemoveUserFromGroupModal(false);
    }

    return (
        <div>
            <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <>
                    <AppBar sx={{position: 'relative'}}>
                        <Toolbar>
                            <Typography sx={{ml: 2, flex: 1}} variant="h6" component="div">
                                {`${user.familyName} ${user.givenName}`}
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleClose}
                                aria-label="close"
                            >
                                <CloseIcon/>
                            </IconButton>
                        </Toolbar>
                    </AppBar>

                    <div style={{ marginTop: '1rem'}}/>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <Key color={'info'}/>
                            </ListItemIcon>
                            <ListItemText
                                primary={"User Pid"}
                                secondary={user.username}
                            />

                        </ListItem>
                        <Divider/>

                        <ListItem>
                            <ListItemIcon>
                                <Email color={'success'}/>
                            </ListItemIcon>
                            <ListItemText
                                primary={"Email"}
                                secondary={user.email}
                            />
                        </ListItem>
                        <Divider/>

                        <ListItem>
                            <ListItemIcon>
                                <Phone color={'primary'}/>
                            </ListItemIcon>
                            <ListItemText
                                primary={"Phone"}
                                secondary={user.phoneNumber}
                            />
                        </ListItem>
                        <Divider/>

                        <ListItem>
                            <ListItemIcon>
                                <LocationCity color={'warning'}/>
                            </ListItemIcon>
                            <ListItemText
                                primary={"Address"}
                                secondary={user.address}
                            />
                        </ListItem>
                        <Divider/>

                            <ListItem>
                                <ListItemIcon>
                                    <Wifi color={"inherit"}/>
                                </ListItemIcon>
                                <ListItemText primary={'Status '} secondary={<Typography>
                                    USER <Switch disabled checked={user.worker === 'true'} color={"info"}/> WORKER
                                </Typography>}/>
                            </ListItem>
                        <Divider/>

                        {
                            groups.length > 0 ?
                               <>
                                   <ListItem>
                                       <ListItemIcon>
                                           <Group color={'primary'}/>
                                       </ListItemIcon>
                                       <ListItemText
                                           primary={"Groups"}
                                           secondary={groups.map((grp, i) =>
                                               <Chip
                                                   sx={{ marginRight: '1rem', marginTop: '.2rem' }}
                                                   variant={"outlined"}
                                                   color={colors[i % colors.length]}
                                                   label={grp.groupName}/>)}
                                       />
                                       <ListItemSecondaryAction>
                                           <IconButton>
                                               <UserGroupEditMenu
                                                   user={user}
                                                   handleShowAddUserToGroupModal={handleSetAddUserToGroupModal}
                                                   handleShowRemoveUserFromGroupModal={handleSetShowRemoveUserFromGroupModal}
                                                   setSelectedUser={setSelectedUser}
                                               />
                                           </IconButton>
                                       </ListItemSecondaryAction>
                                   </ListItem>
                                   <Divider/>
                               </>
                            :
                            <>
                                <ListItem>
                                    <ListItemIcon>
                                        <Group color={'primary'}/>
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={"Groups"}
                                        secondary={"You are not a member of any group"}/>
                                    <ListItemSecondaryAction>
                                        <IconButton>
                                            <UserGroupEditMenu
                                                user={user}
                                                handleShowAddUserToGroupModal={handleSetAddUserToGroupModal}
                                                handleShowRemoveUserFromGroupModal={handleSetShowRemoveUserFromGroupModal}
                                                setSelectedUser={setSelectedUser}
                                            />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                                <Divider/>
                            </>
                        }
                    </List>
                    </>
            </Dialog>
            <AddUserToGroupModal
                user={selectedUser}
                groups={iamGroups}
                setOpen={setShowAddUserToGroupModal}
                open={showAddUserToGroupModal} reload={reload}
            />

            <RemoveUserFromGroupModal
                user={selectedUser}
                groups={iamGroups}
                setOpen={setShowRemoveUserFromGroupModal}
                open={showRemoveUserFromGroupModal}
                reload={reload}
            />
        </div>
    )
}
